// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"723":"977da187","907":"63700d55"}[chunkId] + ".js";
};